import * as types from '../types';

/* --------------------------------- FETCH ---------------------------------- */
export const startFetchingDistributionChannels = (
  operatorId?: number | null,
  organizationId?: number | null,
  divisionId?: number | null,
  subdivisionId?: number | null
) => ({
  type: types.DISTRIBUTION_CHANNELS_FETCH_STARTED,
  payload: { operatorId, organizationId, divisionId, subdivisionId }
});

export const completeFetchingDistributionChannels = (entities: any, order: any) => ({
  type: types.DISTRIBUTION_CHANNELS_FETCH_COMPLETED,
  payload: { entities, order }
});

export const failFetchingDistributionChannels = (error: any) => ({
  type: types.DISTRIBUTION_CHANNELS_FETCH_FAILED,
  payload: { error }
});

/* ---------------------------------- SAVE ---------------------------------- */
export const startSavingDistributionChannel = (distributionChannel: any) => ({
  type: types.DISTRIBUTION_CHANNEL_SAVE_STARTED,
  payload: distributionChannel
});

export const completeSavingDistributionChannel = (distributionChannel: any) => ({
  type: types.DISTRIBUTION_CHANNEL_SAVE_COMPLETED,
  payload: { distributionChannel }
});

export const failSavingDistributionChannel = (error: any) => ({
  type: types.DISTRIBUTION_CHANNEL_SAVE_FAILED,
  payload: { error }
});

/* --------------------------------- DELETE --------------------------------- */
export const startDeletingDistributionChannel = (distributionChannelId: number, name?: string) => ({
  type: types.DISTRIBUTION_CHANNEL_DELETE_STARTED,
  payload: { distributionChannelId, name }
});

export const completeDeletingDistributionChannel = (distributionChannelId: number) => ({
  type: types.DISTRIBUTION_CHANNEL_DELETE_COMPLETED,
  payload: { distributionChannelId }
});

export const failDeletingDistributionChannel = (error: any) => ({
  type: types.DISTRIBUTION_CHANNEL_DELETE_FAILED,
  payload: { error }
});
